export const origin = (typeof window !== 'undefined') ? window.location.origin : 'http://liepaja.lv';



// WEBPACK FOOTER //
// ./src/utils/print.js